import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { HeroChatbox } from './components/HeroChatbox';
import { MarketLensesSection } from './components/MarketLensesSection';
import { FeatureCards } from './components/FeatureCards';
import { CopilotChat } from './components/CopilotChat';
import { MarketLensDashboard } from './components/MarketLensDashboard';
import { CopilotSidebar } from './components/CopilotSidebar';
import { OnboardingFlow } from './components/OnboardingFlow';
import { ViewState, LensData, LensVersion } from './types';
export function App() {
  const [view, setView] = useState<ViewState>('onboarding');
  const [initialPrompt, setInitialPrompt] = useState('');
  const [lensVersions, setLensVersions] = useState<LensVersion[]>([]);
  const [activeVersionId, setActiveVersionId] = useState<string | null>(null);
  const handleStartChat = (prompt: string) => {
    setInitialPrompt(prompt);
    setView('chat');
  };
  const handleGenerateLens = (data: LensData) => {
    const newVersion: LensVersion = {
      id: Date.now().toString(),
      name: lensVersions.length === 0 ? 'Original Lens' : `Lens v${lensVersions.length + 1}`,
      lensData: data,
      createdAt: new Date().toISOString()
    };
    setLensVersions(prev => [...prev, newVersion]);
    setActiveVersionId(newVersion.id);
    setView('dashboard');
  };
  const handleCreateNewVersion = (name: string, data: LensData) => {
    const newVersion: LensVersion = {
      id: Date.now().toString(),
      name,
      lensData: data,
      createdAt: new Date().toISOString()
    };
    setLensVersions(prev => [...prev, newVersion]);
    setActiveVersionId(newVersion.id);
  };
  const handleUpdateLens = (id: string, data: LensData) => {
    setLensVersions(prev => prev.map(v => v.id === id ? {
      ...v,
      lensData: data
    } : v));
  };
  const handleCloseDashboard = () => {
    setView('home');
  };
  const handleOpenLens = (id: string) => {
    setActiveVersionId(id);
    setView('dashboard');
  };
  const activeLens = lensVersions.find(v => v.id === activeVersionId);
  return <div className="flex min-h-screen bg-[#F8FAFC]" data-id="element-0">
      <Sidebar data-id="element-1" />

      <div className="flex-1 ml-16 flex flex-col h-screen overflow-hidden" data-id="element-2">
        {view !== 'onboarding' && <Header data-id="element-3" />}

        <main className="flex-1 overflow-hidden flex flex-col relative" data-id="element-4">
          {view === 'onboarding' && <OnboardingFlow onComplete={() => setView('home')} data-id="element-5" />}

          {view === 'chat' && <div className="absolute inset-0 bg-gray-100/50 p-4 md:p-6 flex flex-col overflow-hidden" data-id="element-6">
              <CopilotChat initialPrompt={initialPrompt} onClose={() => setView('home')} onGenerateLens={handleGenerateLens} data-id="element-7" />
            </div>}

          {view === 'home' && <div className="flex-1 overflow-y-auto" data-id="element-8">
              <HeroChatbox onSubmit={handleStartChat} data-id="element-9" />
              <MarketLensesSection lensVersions={lensVersions} onOpenLens={handleOpenLens} onNewLens={() => setView('chat')} data-id="element-10" />
              <FeatureCards data-id="element-11" />
            </div>}

          {view === 'dashboard' && <div className="flex-1 flex overflow-hidden" data-id="element-12">
              <MarketLensDashboard versions={lensVersions} activeVersionId={activeVersionId} onSelectVersion={setActiveVersionId} onNewLens={() => setView('chat')} onClose={handleCloseDashboard} data-id="element-13" />
              <CopilotSidebar activeLens={activeLens} onUpdateLens={handleUpdateLens} onCreateNewVersion={handleCreateNewVersion} data-id="element-14" />
            </div>}
        </main>
      </div>
    </div>;
}